module.exports = __webpack_public_path__ + "img/p66-launch-seminar-2014.1f5d2755.jpg";